"use strict";

var _objectWithoutProperties = require("/root/website/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loading = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _stylitas = require("@creditas/stylitas");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  size: _propTypes.number
} : {};
var rotate = (0, _stylitas.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"])));

var style = function style() {
  return (0, _stylitas.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: ", " 1s linear infinite;\n"])), rotate);
};

var LoadingStyled = _stylitas.styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), style);

var Loading = function Loading(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 32 : _ref$size,
      props = _objectWithoutProperties(_ref, ["size"]);

  return (0, _core.jsx)(LoadingStyled, {
    "data-testid": "loading"
  }, (0, _core.jsx)("svg", (0, _extends2.default)({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    size: size
  }, props), (0, _core.jsx)("circle", {
    cx: 12,
    cy: 12,
    r: 9.5,
    stroke: "#DBE1DD"
  }), (0, _core.jsx)("mask", {
    id: "Medium_svg__a",
    fill: "#fff"
  }, (0, _core.jsx)("path", {
    d: "M10.648 2.092a10 10 0 0110.594 6.09l-.913.377a9.012 9.012 0 00-9.548-5.488l-.133-.98z"
  })), (0, _core.jsx)("path", {
    d: "M10.648 2.092a10 10 0 0110.594 6.09l-.913.377a9.012 9.012 0 00-9.548-5.488l-.133-.98z",
    stroke: "#1F2D27",
    strokeWidth: 2,
    mask: "url(#Medium_svg__a)"
  })));
};

exports.Loading = Loading;
process.env.NODE_ENV !== "production" ? Loading.propTypes = propTypes : void 0;
Loading.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Loading",
  "props": {
    "size": {
      "defaultValue": {
        "value": "32",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    }
  }
};